import React, { Component } from 'react';
import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { formatDate } from 'helpers/stringUtils';
import combine from 'mout/array/combine';
import filter from 'mout/array/filter';
import BlockTitle from 'components/UI/BlockTitle';
// import EventCardSimple from 'components/Event/EventCardSimple';
import Paragrapher from 'components/UI/Paragrapher';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
// import EventSubscription from "components/EventSubscription/EventSubscription";
// import PopinWrapper from "components/PopinWrapper";
// import EventSubscriptionVisitor from "components/EventSubscription/EventSubscriptionVisitor";
// import EventSubscriptionFor from "components/EventSubscription/EventSubscriptionFor";
import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';
import Paper from '@material-ui/core/Paper';
import { withRouter } from 'react-router-dom';
import i18n from 'helpers/i18n';

const SINGLE_EVENT_SUBSCRIPTION = false;

const styles = (theme) => {
  return {
    root: {
      // cursor: 'pointer',
      '& .MuiTypography-h4': {
        marginBottom: theme.spacing(2),
      },
      '& .MuiTypography-h5': {
        fontWeight: 'normal',
        textAlign: 'center',
        color: theme.palette.text.titleColor,
        textShadow: '1px 1px 2px '+theme.palette.text.shadowColor,
        fontSize: '1.5rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '1.3rem',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.1rem',
        },
      },
    },
    whiteBg: {
      position: 'relative',
      marginBottom: theme.spacing(4),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: 0,
        content: "' '",
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        opacity: 0.9,
        borderRadius: 5
      },
    },
    relative: {
      position: 'relative',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    dateFull: {
      opacity: .5
      // backgroundImage:
      // 'url(' + require('@assets/images/' + process.env.REACT_APP_SITE + '/bubble_disabled.png') + ')',
    },

    dateFullLegend: {
      // position: 'absolute',
      // top: 20,
      // padding: '5px 10px',
      // right: '-30px',
      // transform: 'rotate(35deg)',
      // fontSize: '1.5rem',
      // backgroundColor: theme.palette.secondary.main,
      // color: theme.palette.secondary.contrastText
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      width: '100%',
      fontSize: '1.5rem',
    },

    selectorRoot: {
      // padding: "20px 40px 30px",
      // textAlign: "left",
      // margin: "0 auto",
      // position: "relative",
      // [theme.breakpoints.down("sm")]: {
      //   textAlign: "center",
      // },
    },
    padder: {
      padding: theme.spacing(3),
    },
    dateWrapper: {
      cursor: 'pointer',
      padding: 10,
      // marginBottom: theme.spacing(2),
      transition: [
        theme.transitions.create('background-color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('box-shadow', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      '&:hover': {
        boxShadow: theme.shadows[7],
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '1.17px',
        fontStyle: 'normal',
        // color: theme.palette.common.black,
        // fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px',
          lineHeight: '16px',
        },
      },
      '& .MuiTypography-subtitle1, .MuiTypography-subtitle2 ': {
        color: theme.palette.eventDate.color,
        // color: 'inherit',
      },
    },
    dateWrapperTitle: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '0.8rem',
    },
    title: {
      fontSize: '2rem',
      paddingBottom: theme.spacing(2),
      borderBottom: '2px ' + theme.palette.primary.main + ' solid',
      textAlign: 'left',
      marginBottom: 0,
    },
    description: {
      // fontSize: '2rem',
      color: theme.palette.primary.main,
      textAlign: 'left',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(2)
      }
    },
    dateWrapperSelected: {
      // backgroundColor: theme.palette.secondary.main,
      '& .MuiTypography-subtitle1, .MuiTypography-subtitle2': {
        // color: theme.palette.text.light,
        color: theme.palette.eventDate.colorSelected,
      },
      '& .MuiSvgIcon-root': {
        // color: '#fff',
        // color: theme.palette.primary.main,
        color: theme.palette.eventDate.colorSelected,
      },
    },
    dateWrapperActions: {
      padding: '0',
    },
    dateWrapperActionsButton: {
      transition: [
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('opacity', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      backgroundImage: 'none',
      color: theme.palette.text.light,
      backgroundColor: theme.palette.primary.main,
      fontSize: 22,
      fontWeight: 'bold',
      letterSpacing: '1px',
      padding: '0px 20px',
      border: '1px transparent solid',
      display: 'flex',
      '&:hover': {
        backgroundImage: 'none',
        border: '1px #fff solid',
        backgroundColor: '#fff',
        color: theme.palette.primary.main,
      },
    },
    subscriptionState: {
      position: 'absolute',
      right: 5,
      top: 5,
      '& .MuiSvgIcon-root': {
        color: theme.palette.eventDate.color,
      },
    },
    inline: {
      display: 'inline-block',
    },
    disabled: {
      opacity: 0.5,
    },
    bigButton: {
      fontSize: '1.4rem',
      '&:hover': {
        color: '#fff',
      },
    },
  };
};
class EventSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCard: 0,
      selected: [],
    };
    // this._redirTo = this._redirTo.bind(this);
    // this._onToggleCardSelect = this._onToggleCardSelect.bind(this);
    // this._onSubscriptionComplete = this._onSubscriptionComplete.bind(this);
    // this._onSelectionComplete = this._onSelectionComplete.bind(this);
  }
  componentDidMount() {
    this._setSubscriptions();
  }
  componentDidUpdate(oldProps, oldState) {
    if (oldState.selected.length === 0 && oldProps.$$subscriptions.size !== this.props.$$subscriptions.size) {
      this._setSubscriptions();
    }
  }
  _onSelectionComplete = () => {
    const { onSelectionComplete } = this.props;
    // const { selected } = this.state;
    // console.log('A');
    const $$selectedCards = this._getSelectedCards();
    // console.log($$selectedCards);
    if ($$selectedCards.size < 1) return;
    // console.log('B');
    onSelectionComplete($$selectedCards);
  };
  _setSubscriptions() {
    const { $$subscriptions, $$data } = this.props;
    if ($$subscriptions.size > 0) {
      let arr = [];
      $$subscriptions.map(($s) => arr.push($s));
      let newState = { selected: arr };
      if ($$data !== undefined && $$data.size === 1) {
        newState.selected.push($$data.get(0).get('id'));
        newState.currentCard = $$data.get(0).get('id');
        this.setState(newState, () => {
          this._onSelectionComplete();
        });
      } else {
        this.setState(newState);
      }
    }
  }
  // _redirTo(url) {
  // const { history } = this.props;
  // history.push(url);
  // }
  _getCard = () => {
    const { $$data } = this.props;

    const { currentCard } = this.state;
    if ($$data === undefined) return false;
    else {
      const c = $$data.filter((d) => d.get('id') === currentCard).get(0);
      if (c !== undefined) {
        return c;
      } else if ($$data.get(0) !== undefined) {
        return $$data.get(0);
      } else return false;
    }
  };

  _onToggleCardSelect = (cardId) => {
    const { $$data } = this.props;
    const { selected } = this.state;
    let newSelected = combine([], selected);
    const k = newSelected.indexOf(cardId);

    if ($$data.size === 1 && selected.indexOf(cardId) >= 0) return;
    // console.log('found?',k, cardId, newSelected)
    // console.log('l',selected.length)
    if (SINGLE_EVENT_SUBSCRIPTION === true) newSelected = [];

    if (k >= 0) newSelected = filter(newSelected, (s) => s !== cardId);
    else newSelected.push(cardId);
    // console.log('l',newSelected.length)

    this.setState({ selected: newSelected, currentCard: cardId }, () => {
      // this._onSelectionComplete();
    });
  };
  // _onSubscriptionComplete(r) {
  //   const { onSubscriptionComplete } = this.props;
  //   this.setState(
  //     {
  //       isLoggingIn: false,
  //     },
  //     () => {
  //       onSubscriptionComplete(r);
  //     },
  //   );
  // }
  _getSelectedCards() {
    const { $$data } = this.props;
    const { selected } = this.state;
    const $$selectedCards =
    $$data !== undefined ? $$data.filter((d) => selected.indexOf(d.get('id')) >= 0) : Immutable.fromJS([]);
    return $$selectedCards;
  }
  render() {
    const { $$data, userRole, classes, $$subscriptions, $$user, themeColor } = this.props;
    const { selected, isLoggingIn } = this.state;
    const $$card = this._getCard();
    // const $$selectedCards = this._getSelectedCards();
    // console.log($$selectedCards.toJS())
    // if ($$subscriptions !== undefined)
    // let isSubscribed;
    // console.log(isLoggingIn)
    let isSelected;
    let subscribed;
    return (
      <If condition={$$data !== undefined}>
        <Grid container item spacing={0} xs={12} alignItems="center" className={classes.root}>
          <Grid container item spacing={0} xs={12}>
            <Box align="center" mb={2} width={'100%'}>
              <Typography variant="h5" gutterBottom={true}>
                {i18n.get('selectAnEvent', { prettyfy: false })}
              </Typography>
            </Box>
          </Grid>
          {$$data
            .groupBy($$c => $$c.get('eventInternalReference'))
            .map(($$group, gIdx) => {

              const $$card = $$group.get(0);
              // isSubscribed = $$subscriptions.contains($$card.get('id'));
              return (
                <Grid key={'k_' + gIdx} item xs={12} className={clsx(classes.whiteBg)}>
                  <Grid
                    item
                    container
                    xs={12}
                    container
                    spacing={0}
                    alignItems="flex-start"
                    className={classes.relative}
                    >
                    <Grid item xs={12}>
                      <Typography variant={'h4'} className={classes.title}>
                        <Paragrapher text={$$card.get('eventTitle')} prettyfy={true} element={'span'} />
                      </Typography>
                    </Grid>
                    <If condition={$$card.get('eventDescription') !== '' && $$card.get('eventDescription') !== undefined}>
                      <Grid item xs={12} md={$$group.size < 3 ? 9 : 12}>
                        <div className={classes.description}>
                          <Paragrapher text={$$card.get('eventDescription')} prettyfy={true} />
                        </div>
                      </Grid>
                    </If>
                    <Grid item xs={12} md={$$group.size < 3 ? 3 : 12} spacing={2} container justify="center">
                      {$$group.map(($$e, eIdx) => {
                        isSelected = selected.indexOf($$e.get('id')) >= 0;
                        subscribed = $$subscriptions !== undefined ? $$subscriptions.contains($$e.get('id')) : false;
                        return (<Grid item xs={12} sm={6} md={$$group.size < 3 ? 12 : 4} key={'d_'+eIdx}>

                        <Paper
                          align="center"
                          elevation={3}
                          className={clsx(classes.dateWrapper, {
                            [classes.dateWrapperSelected]: isSelected,
                            [classes.dateFull]: $$e.get('isFull') === 1,
                          })}
                          style={{
                            backgroundColor: isSelected ? themeColor : 'inherit',
                            position: 'relative',
                            color: isSelected ? '#fff' : themeColor,
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            if ($$e.get('isFull') === 1 && subscribed !== true) return;
                            this._onToggleCardSelect($$e.get('id'));
                          }}

                          >
                          <If condition={isSelected === true}>
                            <Typography variant={'caption'} gutterBottom className={classes.subscriptionState}>
                              <CheckBoxIcon style={{ color: 'inherit' }} />
                            </Typography>
                          </If>
                          <If condition={isSelected !== true}>
                            <Typography variant={'caption'} gutterBottom className={classes.subscriptionState}>
                              <CheckBoxOutlineBlankIcon style={{ color: 'inherit' }} />
                            </Typography>
                          </If>

                          <Box style={{ color: themeColor, width: '100%' }}>
                            <Typography variant={'subtitle1'} className={classes.dateWrapperTitle}>
                              {formatDate($$e.get('eventDate'), 'dddd dd mmmm')}
                            </Typography>
                            <Typography variant={'subtitle2'}>
                              <span className={classes.inline}>
                                {formatDate($$e.get('eventDate'), "HH'h'MM")}
                              </span>
                            </Typography>
                          </Box>

                          <If condition={$$e.get('isFull') === 1}>
                            <Box className={classes.dateFullLegend}>Complet !</Box>
                          </If>

                        </Paper>
                      </Grid>)
                    }).toArray()}
                  </Grid>
                </Grid>
              </Grid>
            );
          })
          .toArray()}
          <Grid item xs={12} container justify={'center'}>
            <Box mb={4} className={classes.whiteBg} align="center" py={3} px={6}>
              <Button
                color="primary"
                variant="outlined"
                size="large"
                onClick={(e) => this._onSelectionComplete()}
                disabled={selected.length < 1}
                className={clsx(classes.bigButton)}
                style={{ position: 'relative', backgroundColor: themeColor }}
                >
                {i18n.get('selectAnEventSubmit')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </If>
    );
  }
}

// export default ;
export default withRouter(withStyles(styles)(EventSelector));



// WEBPACK FOOTER //
// ./src/components/Event/EventSelector.jsx